function Overline({ text }: { text?: string }) {
  if (!text) return null;
  return (
    <span className="text-tertiary-variant text-base font-bold sm:text-xl lg:text-2xl">{text}</span>
  );
}

export default Overline;
